import { useMutation } from '@tanstack/react-query'
import { formatPatientName } from '@/utils/formatPatientName'
import { useGeneralStore } from '../../../store/generalStore'
import { api } from '../../Auth/api/api'
import { useDecodedToken } from './useDecodedToken'

interface ChatTokenResponse {
  chat_token: string
}

export const useWebChatMutation = () => {
  const decodedToken = useDecodedToken()
  const { setChatToken } = useGeneralStore()
  const { mutate: startChat } = useMutation({
    mutationFn: async (): Promise<ChatTokenResponse> => {
      if (!decodedToken) {
        throw new Error('Token is missed')
      }

      const { data } = await api.post<ChatTokenResponse>(`/auth/chat-token`, {
        patientId: decodedToken.patient_id,
        patientName: formatPatientName(decodedToken.first_name, decodedToken.middle_name, decodedToken.last_name),
        patientState: decodedToken.state,
        householdId: decodedToken.household_group_id,
      })

      setChatToken(data.chat_token)
      return data
    },
  })

  return { startChat }
}
